export default "__VITE_ASSET__DbkHEvxr__"